import React from 'react'

const ARROW_COLOR = '#555555'
const WIDTH = 1
const ARROW_POINT_SIZE = 12
const ARROW_POINT_BASE = 16
const QUOTE_FONT_SIZE = 12

export const VArrow = ({ height, realHeight, viewQuotes }) => {
  const style = {
    fontFamily: 'Nunito Sans',
    fontWeight: 300,
    fontSize: '12px',
    height: `${height}px`,
  }

  const lineStyle = {
    marginLeft: `${ARROW_POINT_BASE / 2}px`,
    height: `${height - ARROW_POINT_SIZE * 2}px`,
    background: ARROW_COLOR,
    width: `${WIDTH}px`,
    position: 'absolute',
    top: `${ARROW_POINT_SIZE}px`,
  }

  const upArrowStyle = {
    width: 0,
    height: 0,
    borderLeft: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderRight: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderBottom: `${ARROW_POINT_SIZE}px solid ${ARROW_COLOR}`,
    position: 'absolute',
    top: 0,
  }

  const bottomArrowStyle = {
    width: 0,
    height: 0,
    borderLeft: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderRight: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderTop: `${ARROW_POINT_SIZE}px solid ${ARROW_COLOR}`,
    position: 'absolute',
    bottom: 0,
  }

  const quotes = {
    position: 'absolute',
    left: `${ARROW_POINT_BASE + 2}px`,
    top: `${(height / 2) - (QUOTE_FONT_SIZE)}px`,
    visibility: viewQuotes ? 'visible' : 'hidden',
  }


  return (
    <div style={style}>
      <div style={upArrowStyle} />
      <div style={lineStyle} />
      <div style={quotes}>
        {realHeight}
        cm
      </div>
      <div style={bottomArrowStyle} />

    </div>
  )
}

export const HArrow = ({ width, realWidth, viewQuotes }) => {
  const style = {
    fontFamily: 'Nunito Sans',
    fontWeight: 300,
    fontSize: `${QUOTE_FONT_SIZE}px`,
    width: `${width}px`,
  }

  const lineStyle = {
    marginTop: `${ARROW_POINT_BASE / 2}px`,
    width: `${width - ARROW_POINT_SIZE * 2}px`,
    background: ARROW_COLOR,
    height: `${WIDTH}px`,
    position: 'absolute',
    left: `${ARROW_POINT_SIZE}px`,
  }

  const leftArrowStyle = {
    width: 0,
    height: 0,
    borderTop: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderBottom: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderRight: `${ARROW_POINT_SIZE}px solid ${ARROW_COLOR}`,
    position: 'absolute',
    left: 0,
  }

  const rightArrowStyle = {
    width: 0,
    height: 0,
    borderTop: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderBottom: `${ARROW_POINT_BASE / 2}px solid transparent`,
    borderLeft: `${ARROW_POINT_SIZE}px solid ${ARROW_COLOR}`,
    position: 'absolute',
    right: 0,
  }

  const quotes = {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    top: `-${QUOTE_FONT_SIZE + 2}px`,
    visibility: viewQuotes ? 'visible' : 'hidden',
  }

  return (
    <div style={style}>
      <div style={leftArrowStyle} />
      <div style={lineStyle} />
      <div style={quotes}>
        {realWidth}
        cm
      </div>
      <div style={rightArrowStyle} />
    </div>
  )
}
